// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bzU_U","icon":"styles_icon__19cSB"};